/**
 * Host Peer Service
 * 
 * Service for managing peer-to-peer connections and communication from the Participant's side
 */

import { consts } from "../consts";
import { appSyncStore } from "../stores/appSyncStore";
import { appLocalStore } from "../stores/appLocalStore";
import { gameLoaderService } from "./gameLoaderService";
import { webRTCService } from "./webrtcService";

export class ParticipantPeerService {

    private _hostPeerId: string | null = null;

    constructor() {
        // Participant: Listen for snapshots and patches from host
        webRTCService.onMessageReceived((peerId: string, data: any) => {
            switch (data.type) {
                case consts.HOST_INFO:
                    this._hostPeerId = peerId;
                    this.sendToHost({
                        type: consts.USER_INFO,
                        data: {
                            id: appLocalStore.userId,
                            name: appLocalStore.userName,
                            avatar: appLocalStore.userAvatar,
                        },
                    });
                    break;
                case consts.APP_SNAPSHOT:
                    // console.log('[ParticipantPeerService] Received GAME_SNAPSHOT from host:', peerId);
                    appSyncStore.applySnapshot(data.data);
                    break;
                case consts.APP_PATCH:
                    appSyncStore.applyPatch(data.data);
                    break;
                case consts.APP_AVATAR:
                    // console.log('[ParticipantPeerService] Received PLAYER_PROFILE from host:', peerId);
                    const d = data.data;
                    if (d && typeof d.id === 'string'){
                        if (typeof d.avatar === 'string'){
                            appSyncStore.applyUserAvatar(d.id, d.avatar);
                        }
                    }
                    break;
                case consts.APP_AVATAR_SELF:
                    // console.log('[ParticipantPeerService] Received PLAYER_PROFILE_SELF from host:', peerId);
                    const dSelf = data.data;
                    if (dSelf && typeof dSelf.id === 'string'){
                    
                        appSyncStore.applyUserAvatar(dSelf.id, appLocalStore.userAvatar);
                    }
                    break;
                case consts.GAME_SNAPSHOT:
                    const game1 = gameLoaderService.game;
                    if (game1) {
                        game1.gameSyncStore.applySnapshot(data.data);
                    } else {
                        console.error('Game not loaded yet, cannot apply snapshot');
                    }
                    break;
                case consts.GAME_PATCH:
                    const game2 = gameLoaderService.game;
                    if (game2) {
                        game2.gameSyncStore.applyPatch(data.data);
                    } else {
                        console.error('Game not loaded yet, cannot apply patch');
                    }
                    break;
            }
        });
    }

    sendToHost(data: any): boolean {
        if (!this._hostPeerId) {
            console.error('Host peer ID is not set. Cannot send message to host.');
            return false;
        }
        return webRTCService.sendToPeer(this._hostPeerId, data);
    }

    notifyGameLoaded(gameId: string): void {
        this.sendToHost({
            type: consts.GAME_LOADED,
            data: gameId,
        });
    }
}
